import { render, staticRenderFns } from "./PdfRequest.vue?vue&type=template&id=f5a7e8f0"
import script from "@/views/modules/UserReports/js/PdfRequest.js?vue&type=script&lang=js&external"
export * from "@/views/modules/UserReports/js/PdfRequest.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports